import { getSafeJSONValue, setJSONValue } from '../../utils/local-storage'

import { readCSSVariable } from '../../utils/domHelpers'

const navbarColorKey = 'navbarColor'

onDomLoad(function ($dom) {
  $dom.find("div[data-behaviour='save-navbar-color']").each(function () {
    const firmNavColor = readCSSVariable('--sf-color-navigation-bg-firm')
    if (firmNavColor) {
      setJSONValue(navbarColorKey, firmNavColor)
    }
  })
})

onDomLoad(function ($dom) {
  $dom.find("div[data-behaviour='set-navbar-color']").each(function () {
    const firmNavColor = getSafeJSONValue(navbarColorKey)
    if (firmNavColor) {
      document.documentElement.style.setProperty(
        '--paas-navigation-color',
        firmNavColor
      )
    }
  })
})
